import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

/**
 * Composant qui redirige automatiquement vers l'URL avec préfixe langue
 * Ex: /shop → /fr/shop (basé sur détection langue navigateur/géo)
 */
export const LanguageRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { language, setLanguage } = useLanguage();
  
  useEffect(() => {
    const path = location.pathname;
    
    // Routes à exclure de la redirection (pas de préfixe langue)
    const excludedRoutes = ['/admin'];
    const isExcluded = excludedRoutes.some(route => path.startsWith(route));
    
    if (isExcluded) {
      return; // Ne pas rediriger ces routes
    }
    
    // Vérifier si l'URL a déjà un préfixe langue
    const hasLangPrefix = /^\/(fr|en|es|de|it)(\/|$)/.test(path);
    
    if (!hasLangPrefix) {
      // Extraire la langue du path si présente, sinon utiliser langue détectée
      const pathLangMatch = path.match(/^\/(fr|en|es|de|it)/);
      const targetLang = pathLangMatch ? pathLangMatch[1] : language;
      
      // Rediriger avec préfixe langue (301 permanent)
      navigate(`/${targetLang}${path}`, { replace: true });
    } else {
      // Extraire et setter la langue depuis l'URL
      const urlLang = path.match(/^\/(fr|en|es|de|it)/)?.[1];
      if (urlLang && urlLang !== language) {
        setLanguage(urlLang as any);
      }
    }
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps
  
  return null;
};
